module.exports = __webpack_public_path__ + "img/img1.171150f9.png";